module.exports = __webpack_public_path__ + "assets/img/004.da03cf2c.png";